var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPowiadomienieNowe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.5,41c1.99,0,3.7-1.22,4.41-2.96h-8.82c.71,1.73,2.42,2.96,4.41,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.52,28.84h.02c-1.27-.86-2.11-2.32-2.11-3.97v-.14s0-5.52,0-5.52c0-4.92-4.02-8.94-8.94-8.94s-8.94,4.02-8.94,8.94v5.67c0,1.65-.83,3.11-2.1,3.97h.02c-1.09.69-1.81,1.89-1.81,3.28,0,2.15,1.75,3.9,3.9,3.9h17.87c2.15,0,3.9-1.75,3.9-3.9,0-1.38-.73-2.59-1.81-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5,8.55c1.26,0,2.28-1.02,2.28-2.28s-1.02-2.28-2.28-2.28-2.28,1.02-2.28,2.28,1.02,2.28,2.28,2.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.79,28.21c.34.33.51.74.51,1.24s-.17.91-.51,1.25c-.34.34-.76.51-1.27.51s-.96-.17-1.3-.51c-.34-.34-.52-.75-.52-1.25s.17-.91.52-1.24c.34-.33.78-.49,1.3-.49s.93.16,1.27.49Zm-.17-2.38l.56-10.51h-3.32l.54,10.51h2.22Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPowiadomienieNowe);
export default __webpack_public_path__ + "static/media/ico-powiadomienie-nowe.7333aef534bbf24fe2c18f9e900ef764.svg";
export { ForwardRef as ReactComponent };